module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACsAAAAkBAMAAADiJd4mAAAAJ1BMVEUAAAD+8gD/8AD/8wD/8AD/8AD/9AD/8AD98wD/8AD98gD/9AD+8QAY63snAAAADHRSTlMAgMBAv+Bgz5DvoDDWusivAAAAjUlEQVQoz2NgYLA5AwEHGRAAj/ApQRCQQRc+DKZ4BoMwM9B9CZjCjEDPKOAQptRKNhcXlwaeoy4wkIBs9hk4EICqVlJSAqpWggKwMKbZeIQRZhMWRg8TTLNpLdzi4uKNRVjnzJnD2IQVZbAKC/BQU9jFpeY4OKZ8gJE2J8QHyDkT4sBwBhs4wKCEDSgAAEV2lUQIkImaAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/solution/factory_icon.png
// module id = 7gn1
// module chunks = 0